export default function BrevetFiltersMediaSelection() {
    // Used in

    // PROPERTIES

    // HOOKS

    // METHODS

    // BUILD
    return (
        <div></div>
    );
}